export const allCertifications: string[] = ["HHA", "PCA", "CDPAP", "PA", "RN", "LPN"];

// export const allCertifications: string[] = [
//     "HHA",
//     "CNA",
//     "LPN",
//     "OT",
//     "PA",
//     "PCA",
//     "PT",
//     "RN",
//     "ST",
//     "CDPAP"
// ];

export function certificationString(certification: string): string {
  const full = certificationFull(certification);
  if (full !== null) {
    return certification + " - " + full;
  } else {
    return certification;
  }
}

export function certificationFull(certification: string): string | null {
  switch (certification) {
    case "CNA":
      return "Certified Nurse Assistant";
    case "HHA":
      return "Home Health Aide";
    case "LPN":
      return "Licensed Practical Nurse";
    case "OT":
      return "Occupational Therapist";
    case "PA":
      return "Personal Assistant";
    case "PCA":
      return "Personal Care Assistant";
    case "PT":
      return "Physical Therapist";
    case "RN":
      return "Registered Nurse";
    case "ST":
      return "Speech Therapist";
    case "CDPAP":
      return "Consumer Directed Personal Assistance";
    default:
      return null;
  }
}
